/* eslint-disable no-inline-styles/no-inline-styles */
import React, { useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import * as CONSTANTS from 'Utils/constants';
import StepIcon from 'Assets/png/personalised_onboarding/step2.png';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import { advSearchState } from 'Stores/advSearch';
import { companySearchState } from 'Stores/companySearch';
import { Utils } from 'Utils/utils';

const {
  PERSONALIED_ONBOARDING_FLOWS,
  MX_PERSONALISED_ONBOARDING_EVENTS,
} = CONSTANTS;
const {
  EMAIL_CAMPAIGN_LIST,
  TARGETED_ACCOUNTS,
  AD_AUDIENCE_LIST,
} = PERSONALIED_ONBOARDING_FLOWS;
const { LB_GOAL_CURRENT_STEP_VALUE } = MX_PERSONALISED_ONBOARDING_EVENTS;
const { SELECT } = LB_GOAL_CURRENT_STEP_VALUE;

const TITLE = {
  EMAIL_CAMPAIGN_LIST: 'Goal : Email Campaign List - Step 2',
  TARGETED_ACCOUNTS: 'Goal : Build Target Accounts list - Step 2',
  AD_AUDIENCE_LIST: 'Goal : Build Custom Ad Audience - Step 2',
};

const StepTwoTopWrapper = observer(() => {
  const { isPersonalisedOnboardingFlow } = personalisedOnboardingState;
  const handleCloseClick = () => {
    const eventName = Utils.personalisedOnboardingEventMap(
      isPersonalisedOnboardingFlow,
    );
    if (eventName) Utils.mixpanelTrack(eventName, { closed: SELECT });
    personalisedOnboardingState.clearOnboardingFlow();
  };
  return (
    <>
      <div className="sharp-point" />
      <span className="ripple-effect" />
      <div className="close-icon-wrapper">
        <CloseIcon className="close-icon" onClick={e => handleCloseClick()} />
      </div>
      <div className="onboarding-img-wrapper">
        <img src={StepIcon} alt="StepIcon" />
      </div>
      <div className="onboarding-title-wrapper">
        <div className="title">{TITLE[isPersonalisedOnboardingFlow]}</div>
        <div className="progress-bar">
          <div className="progress-bar-fill" />
        </div>
      </div>
    </>
  );
});

const EmailCampaignList = observer(props => {
  const {
    onboardingCurrentStep,
    isPersonalisedOnboardingFlow,
  } = personalisedOnboardingState;
  const [positionData, setPositionData] = useState({
    topPosition: 0,
    leftPosition: 0,
    display: 'none',
  });

  useEffect(() => {
    const element = document.querySelector('.right-section .contact-list-wrap');

    let topPosition = 0;
    let leftPosition = 0;

    if (element) {
      const boundries = element.getBoundingClientRect();
      const { top, left } = boundries;
      topPosition = top;
      leftPosition = left - 297;
      setPositionData({
        topPosition,
        leftPosition,
        display: 'block',
      });
    }
  }, []);

  const handleNextCick = () => {
    if (
      advSearchState.bulkPurchaseIds.length > 0 ||
      advSearchState.bulkRangeCount > 0
    ) {
      const eventName = Utils.personalisedOnboardingEventMap(
        isPersonalisedOnboardingFlow,
      );
      if (eventName) Utils.mixpanelTrack(eventName, { currentStep: SELECT });
      personalisedOnboardingState.setOnboardingCurrentStep(
        onboardingCurrentStep + 1,
      );
    }
  };
  const handleSkipClick = () => {
    const eventName = Utils.personalisedOnboardingEventMap(
      isPersonalisedOnboardingFlow,
    );
    if (eventName) Utils.mixpanelTrack(eventName, { skipped: SELECT });
    personalisedOnboardingState.clearOnboardingFlow();
  };

  return (
    <div
      className="onboarding-flow-step-popup onboarding-flow-step-two-popup "
      style={{
        top: `${positionData.topPosition}px`,
        left: `${positionData.leftPosition}px`,
        display: `${positionData.display}`,
      }}
    >
      <StepTwoTopWrapper />
      <div className="bottom-wrapper">
        <div className="info-title">Select the contacts</div>
        <div className="description">
          <span>View details of contacts based on your search query.</span>
          <span>
            For building your email list, choose multiple contacts using the
            checkbox on the left.
          </span>
        </div>
        <div className="action-btn-wrapper">
          <div className="skip-link" onClick={e => handleSkipClick()}>
            Skip guided tour
          </div>
          <div
            className={`action-btn ${
              advSearchState.bulkPurchaseIds.length > 0 ||
              advSearchState.bulkRangeCount > 0
                ? 'btn-enabled'
                : ''
            }`}
            onClick={e => handleNextCick(e)}
          >
            Next
          </div>
        </div>
      </div>
    </div>
  );
});

const TargetAccountList = observer(props => {
  const {
    onboardingCurrentStep,
    isPersonalisedOnboardingFlow,
  } = personalisedOnboardingState;
  const [positionData, setPositionData] = useState({
    topPosition: 0,
    leftPosition: 0,
    display: 'none',
  });

  useEffect(() => {
    const element = document.querySelector('.right-section .contact-list-wrap');

    let topPosition = 0;
    let leftPosition = 0;

    if (element) {
      const boundries = element.getBoundingClientRect();
      const { top, left } = boundries;
      topPosition = top;
      leftPosition = left - 297;
      setPositionData({
        topPosition,
        leftPosition,
        display: 'block',
      });
    }
  }, []);

  const handleNextCick = () => {
    if (
      companySearchState.hugeSelectionBulkIds.length > 0 ||
      companySearchState.bulkPurchaseIds.length > 0
    ) {
      const eventName = Utils.personalisedOnboardingEventMap(
        isPersonalisedOnboardingFlow,
      );
      if (eventName) Utils.mixpanelTrack(eventName, { currentStep: SELECT });
      personalisedOnboardingState.setOnboardingCurrentStep(
        onboardingCurrentStep + 1,
      );
    }
  };

  const handleSkipClick = () => {
    const eventName = Utils.personalisedOnboardingEventMap(
      isPersonalisedOnboardingFlow,
    );
    if (eventName) Utils.mixpanelTrack(eventName, { skipped: SELECT });
    personalisedOnboardingState.clearOnboardingFlow();
  };

  return (
    <div
      className="onboarding-flow-step-popup onboarding-flow-step-two-popup "
      style={{
        top: `${positionData.topPosition}px`,
        left: `${positionData.leftPosition}px`,
        display: `${positionData.display}`,
      }}
    >
      <StepTwoTopWrapper />
      <div className="bottom-wrapper">
        <div className="info-title">Select the companies</div>
        <div className="description">
          <span>
            You can either select the companies or download all by clicking on
            the top left checkbox
          </span>
        </div>
        <div className="action-btn-wrapper">
          <div className="skip-link" onClick={e => handleSkipClick()}>
            Skip guided tour
          </div>
          <div
            className={`action-btn ${
              companySearchState.hugeSelectionBulkIds.length > 0 ||
              companySearchState.bulkPurchaseIds.length > 0
                ? 'btn-enabled'
                : ''
            }`}
            onClick={e => handleNextCick(e)}
          >
            Next
          </div>
        </div>
      </div>
    </div>
  );
});

const AdAudienceList = observer(props => {
  const {
    onboardingCurrentStep,
    isPersonalisedOnboardingFlow,
  } = personalisedOnboardingState;
  const [positionData, setPositionData] = useState({
    topPosition: 0,
    leftPosition: 0,
    display: 'none',
  });

  useEffect(() => {
    const element = document.querySelector('.right-section .contact-list-wrap');

    let topPosition = 0;
    let leftPosition = 0;

    if (element) {
      const boundries = element.getBoundingClientRect();
      const { top, left } = boundries;
      topPosition = top;
      leftPosition = left - 297;
      setPositionData({
        topPosition,
        leftPosition,
        display: 'block',
      });
    }
  }, []);

  const handleNextCick = () => {
    if (
      companySearchState.hugeSelectionBulkIds.length > 0 ||
      companySearchState.bulkPurchaseIds.length > 0
    ) {
      const eventName = Utils.personalisedOnboardingEventMap(
        isPersonalisedOnboardingFlow,
      );
      if (eventName) Utils.mixpanelTrack(eventName, { currentStep: SELECT });
      personalisedOnboardingState.setOnboardingCurrentStep(
        onboardingCurrentStep + 1,
      );
    }
  };

  const handleSkipClick = () => {
    const eventName = Utils.personalisedOnboardingEventMap(
      isPersonalisedOnboardingFlow,
    );
    if (eventName) Utils.mixpanelTrack(eventName, { skipped: SELECT });
    personalisedOnboardingState.clearOnboardingFlow();
  };

  return (
    <div
      className="onboarding-flow-step-popup onboarding-flow-step-two-popup "
      style={{
        top: `${positionData.topPosition}px`,
        left: `${positionData.leftPosition}px`,
        display: `${positionData.display}`,
      }}
    >
      <StepTwoTopWrapper />
      <div className="bottom-wrapper">
        <div className="info-title">Select the companies</div>
        <div className="description">
          <span>
            You can either select the companies or download all by clicking on
            the top left checkbox
          </span>
        </div>
        <div className="action-btn-wrapper">
          <div className="skip-link" onClick={e => handleSkipClick()}>
            Skip guided tour
          </div>
          <div
            className={`action-btn ${
              companySearchState.hugeSelectionBulkIds.length > 0 ||
              companySearchState.bulkPurchaseIds.length > 0
                ? 'btn-enabled'
                : ''
            }`}
            onClick={e => handleNextCick(e)}
          >
            Next
          </div>
        </div>
      </div>
    </div>
  );
});

const OnboardingStepTwoPopup = observer(props => {
  const { isPersonalisedOnboardingFlow } = personalisedOnboardingState;

  return ReactDOM.createPortal(
    isPersonalisedOnboardingFlow === EMAIL_CAMPAIGN_LIST ? (
      <EmailCampaignList />
    ) : isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS ? (
      <TargetAccountList />
    ) : isPersonalisedOnboardingFlow === AD_AUDIENCE_LIST ? (
      <AdAudienceList />
    ) : (
      ''
    ),
    document.getElementById('portal-dom-root'),
  );
});

export { OnboardingStepTwoPopup };
export default OnboardingStepTwoPopup;
